<template>
  <m-layout-mask :key="$i18n.locale">
    <m-scrollbar>
      <iframe v-bind:src="url" data-anchor="" scrolling="no" width="100%" height="100%" frameborder="0" allowfullscreen></iframe>
    </m-scrollbar>
  </m-layout-mask>
</template>

<script>
import MLayoutMask from '@/components/layouts/MLayoutMask'
import MLayout from '@/components/layouts/MLayout'
import MScrollbar from '@/components/MScrollbar'
import MWidgetHead from '@/components/widget/MWidgetHead'
import MHideToggler from '@/components/buttons/MHideToggler'
import { mapState } from 'vuex'

export default {
  components: { MLayoutMask, MLayout, MScrollbar, MWidgetHead, MHideToggler },
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  data () {
    return {
      compactSidebar: false,
      url: ''
    }
  },
  mounted () {
    if (this.user !== null) {
      this.url = 'https://rate.demobetstil.ru/inbet/games/user/' + this.user.id + '/lang/' + this.$i18n.locale
    }
  },
  watch: {
    '$i18n.locale' (to, from) {
      if (this.user !== null) {
        this.url = 'https://rate.demobetstil.ru/inbet/games/user/' + this.user.id + '/lang/' + this.$i18n.locale
      }
    }
  },
  methods: {
    goBack () {
      if (this.user !== null) {
        this.url = 'https://rate.demobetstil.ru/inbet/games/user/' + this.user.id + '/lang/' + this.$i18n.locale
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/kazino/Kazino.vue